module.exports = __webpack_public_path__ + "static/media/view3.e0da74d2.jpg";